import Icon from '../../components/Icon.vue'

Icon.register({"regular/arrow-alt-circle-right":{"width":512,"height":512,"paths":[{"d":"M504 256C504 119 393 8 256 8S8 119 8 256 119 504 256 504 504 393 504 256zM56 256C56 145.5 145.5 56 256 56S456 145.5 456 256 366.5 456 256 456 56 366.5 56 256zM128 276V236C128 229.4 133.4 224 140 224H256V157C256 146.3 268.9 141 276.5 148.5L375.5 247.5C380.2 252.2 380.2 259.8 375.5 264.5L276.5 363.5C268.9 371.1 256 365.7 256 355V288H140C133.4 288 128 282.6 128 276z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-right.js
// module id = 8+og
// module chunks = 0